import React from 'react';

const WhiteBlock = ({t}) =>{
  return (
    <div className="white-block">
      <div className="white-text">
          <span>{t("white_block_span_1")}</span>
          <span>{t("white_block_span_2")}</span> 
          <span>{t("white_block_span_3")}</span> 
      </div>
    </div>
    
  );
}

export default WhiteBlock;